(() => {
  if (window.ravinFashionLabCartActive) return;
  window.ravinFashionLabCartActive = true;
  const cleanup = new WeakMap();
  const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
  function init(root) {
    if (cleanup.has(root)) return;
    const ctl = new AbortController();
    const signal = ctl.signal;
    const cards = Array.from(root.querySelectorAll('[data-rfl-card]'));
    const dock = root.querySelector('[data-rfl-dock]');
    const next = root.querySelector('[data-rfl-next]');
    const description = root.querySelector('[data-rfl-description]');
    const heads = root.querySelectorAll('[data-rfl-head]');
    const labels = root.querySelectorAll('[data-rfl-number]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(pointer: fine)');
    let copy = {};
    try { copy = JSON.parse(root.querySelector('[data-rfl-copy]')?.textContent || '{}'); } catch (_) {}
    let count = Number(root.dataset.rflCount) || 0;
    let frame = 0;
    let unsubscribe = null;
    if (dock) {
      dock.style.setProperty('--rfl-accent', getComputedStyle(root).getPropertyValue('--rfl-accent'));
      document.body.append(dock);
      dock.querySelector('[data-rfl-checkout]')?.addEventListener('click', () => {
        const checkout = document.querySelector('#main-cart-footer button[name="checkout"]');
        if (checkout && !checkout.disabled) checkout.click();
      }, { signal });
    }
    function syncTotal() {
      const total = document.querySelector('#main-cart-footer .totals__total-value');
      const mobile = dock?.querySelector('[data-rfl-dock-total]');
      if (total && mobile) mobile.textContent = total.textContent.trim();
    }
    function syncState(nextCount) {
      count = Number(nextCount) || 0;
      root.classList.toggle('rfl-cart--empty', count === 0);
      root.dataset.rflCount = String(count);
      labels.forEach(x => x.textContent = String(count));
      if (dock) dock.hidden = count === 0;
      const content = count === 0 ? copy.empty : copy.full;
      if (content) {
        heads.forEach((el, i) => el.textContent = content.lines?.[i] || '');
        if (description) description.textContent = content.description;
        if (next) {
          next.href = count ? '#main-cart-items' : next.dataset.rflShopUrl;
          const label = next.querySelector('[data-rfl-next-text]');
          if (label) label.textContent = content.link;
        }
      }
    }
    function syncProducts(data) {
      if (!data || !Array.isArray(data.items)) return;
      syncState(data.item_count);
      root.dataset.rflLines = String(data.items.length);
      cards.forEach((card, i) => {
        const item = data.items[i];
        card.hidden = !item;
        if (!item) {card.setAttribute('tabindex', '-1');return;}
        card.removeAttribute('tabindex');
        const label = item.product_title || item.title || '';
        card.href = item.url || '/collections/all';
        card.setAttribute('aria-label', label);
        const heading = card.querySelector('[data-rfl-card-title]');
        if (heading) heading.textContent = label;
        const image = card.querySelector('.rfl-cart__image');
        if (image) {
          const src = item.image || item.featured_image?.url;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          if (typeof src === 'string' && /^https?:\/\/|^\/\//.test(src)) {
            image.src = src;
            image.alt = label;
            image.classList.remove('rv-youssef-image');
            image.hidden = false;
          } else {
            image.src = 'https://cdn.shopify.com/s/files/1/0013/7743/5701/files/ravin-youssef-missing-product-image-2026.jpg?v=1792392181';
            image.alt = 'Product image coming soon. Youssef is still buffering.';
            image.classList.add('rv-youssef-image');
            image.hidden = false;
          }
        }
      });
      window.requestAnimationFrame(() => window.requestAnimationFrame(syncTotal));
      measureLater();
    }
    function measure() {
      frame = 0;
      const viewport = window.innerHeight;
      const cartSection = document.querySelector('cart-items');
      const cartTop = cartSection?.getBoundingClientRect().top ?? viewport * 2;
      const progress = clamp((viewport * 0.9 - cartTop) / (viewport * 0.9), 0, 1);
      const motion = root.dataset.rflMotion === 'true' && !reduced.matches;
      root.style.setProperty('--rfl-lift', motion ? (-55 * progress).toFixed(1) + 'px' : '0px');
      root.style.setProperty('--rfl-scroll-rotate', motion ? (2.4 * progress).toFixed(1) + 'deg' : '0deg');
      if (dock) {
        const native = document.querySelector('#main-cart-footer button[name="checkout"]');
        const bounds = native?.getBoundingClientRect();
        const nativeInView = Boolean(bounds && bounds.width > 0 && bounds.height > 0 &&
          bounds.top >= 88 && bounds.bottom <= viewport - 12 &&
          bounds.left >= 0 && bounds.right <= window.innerWidth);
        const visible = count > 0 && !nativeInView;
        dock.classList.toggle('is-visible', visible);
        const button = dock.querySelector('[data-rfl-checkout]');
        if (button) button.disabled = !native || native.disabled;
      }
    }
    function measureLater() { if (!frame) frame = window.requestAnimationFrame(measure); }
    function pointerMove(e) {
      if (root.dataset.rflMotion !== 'true' || reduced.matches || !finePointer.matches) return;
      const bounds = root.getBoundingClientRect();
      const px = clamp((e.clientX - bounds.left) / bounds.width * 2 - 1, -1, 1);
      const py = clamp((e.clientY - bounds.top) / bounds.height * 2 - 1, -1, 1);
      cards.forEach((card, i) => {
        const strength = (i + 1) / 3;
        card.style.setProperty('--rfl-rx', (-py * 4 * strength).toFixed(1) + 'deg');
        card.style.setProperty('--rfl-ry', (px * 7 * strength).toFixed(1) + 'deg');
      });
    }
    function pointerReset() {
      cards.forEach(card => {
        card.style.removeProperty('--rfl-rx');
        card.style.removeProperty('--rfl-ry');
      });
    }
    root.addEventListener('pointermove', pointerMove, {passive: true, signal});
    root.addEventListener('pointerleave', pointerReset, {signal});
    window.addEventListener('scroll', measureLater, {passive: true, signal});
    window.addEventListener('resize', measureLater, {passive: true, signal});
    window.addEventListener('pageshow', measureLater, {signal});
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.cartData?.items) {
          syncProducts(event.cartData);
        } else {
          fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {'Accept': 'application/json'}})
            .then(r => r.ok ? r.json() : null).then(syncProducts).catch(() => {});
        }
        requestAnimationFrame(() => requestAnimationFrame(syncTotal));
      });
    }
    cleanup.set(root, () => {
      ctl.abort();
      if (unsubscribe) unsubscribe();
      if (frame) cancelAnimationFrame(frame);
      dock?.remove();
      cleanup.delete(root);
    });
    syncTotal();
    measure();
  }
  function scan(el) {
    if (el.matches?.('[data-rfl-cart]')) init(el);
    el.querySelectorAll?.('[data-rfl-cart]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => {
    const els = e.target.matches?.('[data-rfl-cart]') ? [e.target] : Array.from(e.target.querySelectorAll?.('[data-rfl-cart]') || []);
    els.forEach(el => cleanup.get(el)?.());
  });
})();